import {createDeleteSlice} from "../genericCrudSlice";
import {deleteWalletApi} from "../../api/entities/wallets";

const deleteWalletSlice = createDeleteSlice('delete', deleteWalletApi);
export const {init} = deleteWalletSlice.actions;
export const {deleteEntity: deleteWallet} = deleteWalletSlice;
export default deleteWalletSlice.reducer;